import { render, staticRenderFns } from "./CaseConfigDocuments.vue?vue&type=template&id=61122c45"
import script from "./CaseConfigDocuments.vue?vue&type=script&lang=js"
export * from "./CaseConfigDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports